var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.6515,
    stroke: "#0080B1",
    strokeWidth: 0.69697
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5769 29.9116C26.18 29.9116 29.9116 26.18 29.9116 21.5769C29.9116 16.9738 26.18 13.2422 21.5769 13.2422C16.9738 13.2422 13.2422 16.9738 13.2422 21.5769C13.2422 26.18 16.9738 29.9116 21.5769 29.9116Z",
    stroke: "#0080B1",
    strokeWidth: 1.25455
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5759 18.0068C20.6286 18.0068 19.72 18.3832 19.0501 19.0531C18.3802 19.7229 18.0039 20.6315 18.0039 21.5789M32.292 32.2949L28.72 28.7229",
    stroke: "#0080B1",
    strokeWidth: 1.39394,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleResearch);
export default __webpack_public_path__ + "static/media/icon-circle-research.c1fb0c4dc3e1985bbd3dedd0c07484f0.svg";
export { ForwardRef as ReactComponent };